import { render, staticRenderFns } from "./ViewEntityTransaction.vue?vue&type=template&id=40721ca1&scoped=true"
import script from "./ViewEntityTransaction.vue?vue&type=script&lang=js"
export * from "./ViewEntityTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40721ca1",
  null
  
)

export default component.exports